module.exports = __webpack_public_path__ + "static/media/main_cover.acd9c463.png";